// The app a handoff code lands on (AuthHandoffCode::TARGETS): another admin domain, or react-ux
export const HANDOFF_TARGETS = {
  admin: 'admin',
  ux: 'ux',
};
